<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title #title (click)="onTitleClick()" data-test="title">Service Areas Multiple</ion-title>
        <!-- <ion-buttons slot="end">
            <ion-button [disabled]=vb.disabled color="light" id="more" (click)="onMoreClick($event)">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons> -->
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list-header color="secondary">
        Within the same state as the dealership, find all zipcodes within a specified radius of the dealership.
    </ion-list-header>

    <ion-list lines="none">
        <ion-item>
            <ion-label class="ion-text-wrap">
                <span class="line1">Dealership Address</span><br />
                <span class="line2" id="dealershipAddress">{{serviceArea.dealershipAddress}}</span>
            </ion-label>
        </ion-item>

        <!-- <ion-item>
            <ion-label ion-text-wrap position="stacked">
                Approximate Miles From Dealership To Center of Zipcode
            </ion-label>
            <ion-input id="radius" type="number" autoFocus="true" 
                [(ngModel)]="serviceArea.radius" data-test="radius"></ion-input>
            <ion-button expand="full" slot="end" class="zipcodesButton" (click)="doFindZipcodes()">
                Find Zipcodes
            </ion-button>
        </ion-item> -->

        <ion-item>
            <ion-label class="ion-text-wrap">
                <span class="line1">Search For Nearby Zipcodes:</span><br />
                <span class="line2">{{serviceArea.radiusStr}} From Dealership</span>
            </ion-label>
        </ion-item>
        <ion-item>
            <ion-range class="insetRange" min="1" max="50" step="1" snaps="true" [(ngModel)]="serviceArea.radius"
                (ionChange)="onRadiusChange()" color="primary" data-test="radius">
                <ion-label class="ion-text-wrap" color="primary" slot="start">5</ion-label>
                <ion-label class="ion-text-wrap" color="primary" slot="end">50</ion-label>
            </ion-range>
        </ion-item>

        <ion-item>
            <ion-toolbar class="myToolbar">
                <ion-button color="primary" expand="full" class="zipcodesButton ion-margin" (click)="doFindZipcodes()"
                    data-test="find">
                    Search For Nearby Zipcodes
                </ion-button>
            </ion-toolbar>
        </ion-item>
    </ion-list>

    <ion-list>
        @for (zip of selectedZips; track $index) {
  <ion-item data-test="zips">
            <div>
                <span class="line1" id="line1">{{zip.line1}}</span><br />
                <span class="line1" id="line2">{{zip.line2}}</span>
            </div>
        </ion-item>
}
    </ion-list>
</ion-content>

<ion-footer>
    <ion-toolbar>
        <ion-button color="primary" expand="full" (click)="onSaveClick()" data-test="saveMultipleBtn">Save</ion-button>
    </ion-toolbar>
</ion-footer>